export default __webpack_public_path__ + "static/media/bgHotel.a216bc01.jpg";